import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import MultiselectTaxes from 'Components/Organisms/MultiselectTaxes/MultiselectTaxes';

export default function RHFSelectMultipleTaxes({ name, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <MultiselectTaxes {...field} error={error?.message} {...other} />
            )}
        />
    );
}

RHFSelectMultipleTaxes.propTypes = {
    name: PropTypes.string.isRequired,
};
